import { createLogic } from 'redux-logic'
import handleErrors from '@app/helpers/handleErrors'
import { CANCEL_ZWAVE_DELETE } from '@app/constants/myDevices/zwaveDevices'
import { API_REQUEST_CANCEL } from '@app/constants/apiRequest'
import { apiRequestDone, apiRequestFailed, apiRequestSent } from '@app/actions/apiRequest'
import Api from '@app/api/myDevices/deviceSettings/zwaveDevices'

const cancelZwaveDeleteLogic = createLogic({
  type: CANCEL_ZWAVE_DELETE,
  cancelType: API_REQUEST_CANCEL,

  transform({ getState, action }, next) {
    const { secrets: { accessToken: { token: accessToken } } } = getState()
    next({
      ...action,
      accessToken,
    })
  },

  async process({ action }, dispatch, done) {
    dispatch(apiRequestSent(CANCEL_ZWAVE_DELETE))
    try {
      await Api.cancelZwaveDelete(action.accessToken)
      dispatch(apiRequestDone(CANCEL_ZWAVE_DELETE))
    } catch (error) {
      if (error) {
        const currentError = handleErrors(error)
        dispatch(apiRequestFailed(currentError))
      } else {
        throw new Error('CANCEL_ZWAVE_DELETE failed without error')
      }
    }
    done()
  },
})

export default cancelZwaveDeleteLogic
